import { t as uiText } from '../../i18n';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import {
  DEFAULT_WORKSPACE_BASE_COLOR_KEY,
  isWorkspaceBaseColorKey,
  type WorkspaceBaseColorKey,
} from '../../theme/workspaceBaseColors';

export interface UpdateWorkspaceSettingsParams {
  workspaceId: string;
  name: string;
  baseColorKey?: WorkspaceBaseColorKey;
  /**
   * 内部 RAG: 回答内の参照 URL を読み取って補足回答するかどうか。
   * 未指定時は Firestore 側の既存値を維持する。
   */
  crawlReferencedUrls?: boolean;
}

export const updateWorkspaceSettings = async ({
  workspaceId,
  name,
  baseColorKey,
  crawlReferencedUrls,
}: UpdateWorkspaceSettingsParams): Promise<void> => {
  try {
    const workspaceRef = doc(db, 'workspaces', workspaceId);
    const resolvedBaseColorKey =
      baseColorKey && isWorkspaceBaseColorKey(baseColorKey)
        ? baseColorKey
        : DEFAULT_WORKSPACE_BASE_COLOR_KEY;

    const updatePayload: Record<string, unknown> = {
      name,
      baseColorKey: resolvedBaseColorKey,
      updatedAt: new Date(),
    };

    if (typeof crawlReferencedUrls === 'boolean') {
      updatePayload.crawlReferencedUrls = crawlReferencedUrls;
    }

    await updateDoc(workspaceRef, updatePayload);
  } catch (error) {
    console.error('🔄 updateWorkspaceSettings: エラーが発生しました:', error);
    throw new Error(uiText("Failed to update workspace settings"));
  }
};

/** 内部 RAG の参照 URL 補足 ON/OFF だけを更新する */
export const updateCrawlReferencedUrls = async (
  workspaceId: string,
  crawlReferencedUrls: boolean
): Promise<void> => {
  try {
    const workspaceRef = doc(db, 'workspaces', workspaceId);
    await updateDoc(workspaceRef, {
      crawlReferencedUrls,
      updatedAt: new Date(),
    });
  } catch (error) {
    console.error('🔄 updateCrawlReferencedUrls: エラーが発生しました:', error);
    throw new Error(uiText("Failed to update referenced URL follow-up settings"));
  }
}; 